// extracted by mini-css-extract-plugin
export default {"container":"styles_container__FtjGt","buttonsContainer":"styles_buttonsContainer__3PETn"};